import { render } from "./Publicaties.vue?vue&type=template&id=96acdb32&scoped=true"
import script from "./Publicaties.vue?vue&type=script&lang=js"
export * from "./Publicaties.vue?vue&type=script&lang=js"

import "./Publicaties.vue?vue&type=style&index=0&id=96acdb32&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-96acdb32"]])

export default __exports__